const GOOGLE_TAG_MANAGER_SCRIPT = `(function (w, d, s, l, i) {
  w[l] = w[l] || []; w[l].push({
    'gtm.start':
      new Date().getTime(), event: 'gtm.js'
  }); var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-TQQRRFDS');`;

const GOOGLE_TAG_MANAGER_NOSCRIPT = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TQQRRFDS" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

export const loadGoogleTagManagerScript = () => {
  if (document.getElementById('gtm-script')) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.innerHTML = GOOGLE_TAG_MANAGER_SCRIPT;
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  noscript.id = 'gtm-noscript';
  noscript.innerHTML = GOOGLE_TAG_MANAGER_NOSCRIPT;
  document.body.appendChild(noscript);
};
